import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CoreRoutingModule } from './presentation';
import { RouterModule } from '@angular/router';
import { AppEffectsModule } from './application/store/app.effects';
import { ApplicationStoreModule } from './application/store/app.store';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { SharedModule } from '../modules';

export * from './application';
export * from './presentation';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CoreRoutingModule,
    EffectsModule.forRoot([]),
    ApplicationStoreModule,
    AppEffectsModule,
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    SharedModule,
  ],
  exports: [RouterModule, StoreModule],
})
export class CoreModule {}
